module.exports = __webpack_public_path__ + "static/media/excel.9cd9e431.svg";